var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.345 31.976C25.236 31.538 31.5 25.001 31.5 17c0-8.284-6.716-15-15-15s-15 6.716-15 15c0 2.952.852 5.704 2.325 8.025l-1.06 3.18-.002.005c-.406 1.218-.61 1.827-.465 2.233.126.353.406.632.76.758.404.144 1.009-.058 2.219-.461l.017-.005 3.181-1.06a14.93 14.93 0 0 0 8.87 2.301m0 0q0 0 0 0m0 0C19.398 37.815 24.96 42 31.5 42c2.952 0 5.704-.853 8.025-2.325l3.18 1.06h.006c1.218.407 1.829.61 2.234.466a1.25 1.25 0 0 0 .756-.758c.145-.406-.058-1.017-.465-2.238l-1.06-3.18.355-.588A14.93 14.93 0 0 0 46.499 27c0-8.284-6.715-15-14.999-15l-.561.01-.284.014",
    stroke: "url(#a)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 27.067,
    y1: 47.556,
    x2: -16.591,
    y2: 22.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ED84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F5E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84FAD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.e5c71591573fda32c83424a4caff07d2.svg";
export { ForwardRef as ReactComponent };